import { call, put, takeLeading, takeLatest } from 'redux-saga/effects';
import UserManagementService from '../api/userManagement';
import { userManagementActions } from '../reducers/user-management';

function* getAllUserList({ payload }: any): any {
  const res = yield call(UserManagementService.fetchUserList, payload);
  if (res.status === 'success') {
    yield put(userManagementActions.getUserListResponse(res));
  } else {
    yield put(userManagementActions.getUserListFailed(res?.code));
  }
}

function* addUserCall({ payload }: any): any {
  const res = yield call(UserManagementService.addNewUser, payload);
  if (res.status === 'success') {
    yield put(userManagementActions.addUserResponse(res.code));
  } else {
    yield put(userManagementActions.addUserRequestFailed(res?.code));
  }
}

function* updateUserCall({ payload }: any): any {
  const res = yield call(UserManagementService.updateUser, payload);
  if (res.status === 'success') {
    yield put(userManagementActions.updateUserResponse(res.code));
  } else {
    yield put(userManagementActions.updateUserFailed(res?.code));
  }
}

function* deleteUserCall({ payload }: any): any {
  const res = yield call(UserManagementService.deleteUsers, payload);
  if (res.status === 'success') {
    yield put(userManagementActions.deleteMultipleUserResponse(res.code));
  } else {
    yield put(userManagementActions.deleteMultipleUserFailed(res?.code));
  }
}

function* getUserAccessList({ payload }: any): any {
  const res = yield call(UserManagementService.fetchUserAccessList, payload);
  if (res.status === 'success') {
    yield put(userManagementActions.getUserAccessListResponse(res));
  } else {
    yield put(userManagementActions.getUserAccessListFailed(res?.code));
  }
}

function* UserManagementSaga() {
  yield takeLatest('userManagement/getUserList', getAllUserList);
  yield takeLeading('userManagement/addUserRequest', addUserCall);
  yield takeLeading('userManagement/updateUserRequest', updateUserCall);
  yield takeLeading('userManagement/deleteMultipleUserRequest', deleteUserCall);
  yield takeLeading('userManagement/getUserAccessList', getUserAccessList);
}

export default UserManagementSaga;
